<template>
    <div>
        <div
            v-if="(locale === 'en' || locale === 'de') && index === 6 && currentPage === 1 && bannerInsights.length > 0"
            class="insightBanner__container">
            <insight-banner
                v-if="checkInArray('market')"
                :insight="true"
                :banner-name="'market'"
                :banner-icon="'#iconMarketInsightsSquare'"
                :banner-title="'Market Insights'"
                :banner-content="trans('MARKET_INSIGHT_TEXT')"
                :banner-content-count="trans('MARKET_INSIGHT_TEXT_WITH_COUNT', { '{count}': resultCounterMarket })"
                :banner-content-single-count="trans('MARKET_INSIGHT_TEXT_WITH_SINGLE_COUNT')"
                :banner-link-title="trans('MARKET_INSIGHT_LINK')"
                :banner-link="true"
                :insight-result="true"
                :insight-result-counter="resultCounterMarket" />
            <insight-banner
                v-if="checkInArray('consumer')"
                :insight="true"
                :banner-name="'gcs'"
                :banner-icon="'#iconConsumerInsightsSquare'"
                :banner-title="'Consumer Insights'"
                :banner-content="trans('CONSUMER_INSIGHT_TEXT')"
                :banner-content-count="trans('CONSUMER_INSIGHT_TEXT_WITH_COUNT', { '{count}': resultCounterConsumer })"
                :banner-content-single-count="trans('CONSUMER_INSIGHT_TEXT_WITH_SINGLE_COUNT')"
                :banner-link-title="trans('CONSUMER_INSIGHT_LINK')"
                :banner-link="true"
                :insight-result="true"
                :insight-result-counter="resultCounterConsumer" />
            <insight-banner
                v-if="checkInArray('default')"
                :insight="false"
                :banner-title="'Explore more insights'"
                :banner-content="'No insights content'"
                :banner-link="false" />
        </div>
        <a
            class="text--linkReset resultList__itemBox"
            :class="{ 'itemContainer--editorial': promoted }"
            :data-gtm="`searchItem--${ item.idcontent }`"
            :target="item.identity === '54' || item.identity === '55' ?'_blank':'_self'"
            :href="path(item)"
            @keydown.enter="addDataLayer"
            @keydown.right="changeFocus">
            <div
                class="itemContent text-ellipsis"
                :data-gtm="`searchResult__page${ currentPage }--position${ absolutePosition }${ promoted ? ' searchResult__promotion' : '' }`"
                @click="addDataLayer">
                <span
                    class="item__icon iconSprite resultList__item"
                    :class="[`iconSprite--${ getIcon(item) }`]">
                </span>
                <span class="item__text">{{ getGroupType(item) }} {{ (item.tstampreleased || item.tstampupdated) ? ' | ' : '' }}  {{ (item.tstampreleased || item.tstampupdated) ? formatDate(item.tstampreleased ? item.tstampreleased : item.tstampupdated) : '' }}</span>
                <div
                    class="itemContent__text"
                    :class="{ 'text-ellipsis': promoted, 'itemContent__textWithIcon': item.identity === '54' || item.identity === '55' } ">
                    {{ getTitle(item) }}
                    <svg
                        v-if="item.identity === '54' || item.identity === '55'"
                        width="16"
                        height="16"
                        aria-hidden="true"
                        class="item__icon--newTab">
                        <use href="#iconNewTab" />
                    </svg>
                </div>
                <div class="itemContent__subline resultList__itemSubHeadline">
                    <span v-if="contentOwner && owner">
                        <span class="text-bold">
                            {{ owner }}
                        </span> –
                    </span>
                    <span v-html="newSubtitle"></span>
                </div>
            </div>
            <div
                v-if="promoted"
                class="itemContent__editorialWrapper">
                <span class="itemContent__editorial">
                    {{ trans('EDITORIAL_PICK') }}
                </span>
            </div>
        </a>
    </div>
</template>

<script>
    import { useGetters, useActions } from 'composables/useVuex';
    import Translator from 'tools/trans';
    import { pushToDataLayerResult } from 'search/dataLayer';
    import InsightBanner from './components/insightBanner';

    const CONSUMER = 'consumer';
    const MARKET = 'market';
    const GCS = 'gcs';
    const DEFAULT = 'default';
    const EMPTY_ARRAY = [];
    const BANNER_POSITION = 6;
    const FIRST_PAGE = 1;
    const GCSREPORT = 'gcsReports';
    export default {
        name: 'ShowItem',
        components: {
            InsightBanner,
        },
        props: {
            item: { type: Object, required: true },
            promoted: { type: Boolean, default: false },
            index: { type: Number, default: 0 },
            insight: { type: Boolean, default: false },
        },
        data() {
            return {
                locale: window.stGlobals.locale,
                eComItem: this.item.identity === '54' || this.item.identity === '55',
            };
        },
        computed: {
            absolutePosition() {
                const ENTRY_POSITION = this.index + 1;
                const FIRST_PAGE_RESULTS = 25;
                const PAGE_RESULTS_50 = 50;
                const PAGE_RESULTS_100 = 100;
                const RESULTS_BEFORE_PAGE_5 = 225;
                if (this.currentPage === 1) {
                    return ENTRY_POSITION;
                } else if (this.currentPage > 1 && this.currentPage < 5) {
                    return ENTRY_POSITION + (this.currentPage - 1) * PAGE_RESULTS_50 - FIRST_PAGE_RESULTS;
                } else {
                    return ENTRY_POSITION + (this.currentPage - 1) * PAGE_RESULTS_100 - RESULTS_BEFORE_PAGE_5;
                }
            },
            owner() {
                return (this.contentOwners && this.item.idowner && Object.keys(this.contentOwners).includes(this.item.idowner)) ? this.contentOwners[Number(this.item.idowner)] : false;
            },
            newSubtitle() {
                const uri = window.location.search.substring(1);
                const URLSearchParams = window.URLSearchParams;
                const urlParams = new URLSearchParams(uri);
                const query = urlParams.get('q') ? urlParams.get('q') : '';
                const searchArray = query.trim().split(' ');
                if (searchArray.length > 1) {
                    searchArray.push(query.trim());
                }
                const pattern = searchArray.map((p) => `\\b${ p.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&') }\\b`).join('|');
                const regex = new RegExp(pattern, 'gi');

                return this.getContent(this.item).replace(regex, this.makeBold);
            },
            resultCounterMarket() {
                return this.getOriginalMetric(MARKET);
            },
            resultCounterConsumer() {
                if (window.stGlobals.user && this.userPermissionToGCS) {
                    return this.getOriginalMetric(GCS) + this.getOriginalMetric(GCSREPORT);
                }

                return this.getOriginalMetric(GCSREPORT);
            },
            isRightPositionForBanner() {
                return (this.promotedArray.length + this.index) === BANNER_POSITION && this.currentPage === FIRST_PAGE;
            },
        },
        watch: {
            applyFilterClicked(value) {
                if (value) {
                    if (this.isRightPositionForBanner) {
                        this.calculateWhichBannerToShow();
                    }
                }
            },
            resetFilterClicked(value) {
                if (value) {
                    if (this.isRightPositionForBanner) {
                        this.calculateWhichBannerToShow();
                    }
                }
            },
            loading(value) {
                if (value) {
                    if (this.isRightPositionForBanner) {
                        this.calculateWhichBannerToShow();
                    }
                }
            },
        },
        methods: {
            trans: Translator.trans,
            formatDate(timestamp) {
                const date = new Date(parseInt(timestamp) * 1000);
                const formattedDate = date.toLocaleDateString(this.locale, { year: 'numeric', month: 'long', day: 'numeric' });

                return formattedDate;
            },
            changeFocus() {
                const facetedSearch = document.querySelector('[data-faceted-search]');
                const expertSearch = document.querySelector('[data-expert-search]');
                if (facetedSearch) {
                    facetedSearch.firstElementChild.firstElementChild.focus();
                } else {
                    expertSearch.focus();
                }
            },
            addDataLayer() {
                const contentId = parseInt(this.item.idcontent);
                const contentType = this.getGroupType(this.item);
                const itemPosition = this.index + 1;

                pushToDataLayerResult(itemPosition, contentId, contentType, this.promoted);
            },
            makeBold(match) {
                return `<b>${ match }</b>`;
            },
            // calculate which banner to show
            async calculateWhichBannerToShow() {
                const insightArray = [];
                try {
                    if (this.getTabGroup.length === 0) {
                        if (this.query === '') {
                            insightArray.push(CONSUMER, MARKET);
                        } else {
                            await this.setBannerInsights(EMPTY_ARRAY);
                            this.addToInsight(insightArray, CONSUMER, Number(this.getOriginalMetric(GCS)) + Number(this.getOriginalMetric(GCSREPORT)));
                            this.addToInsight(insightArray, MARKET, this.getOriginalMetric(MARKET));
                        }
                    }
                    if (insightArray.length === 1) {
                        insightArray.push(DEFAULT);
                    }
                    this.setBannerInsights(insightArray);
                } catch (err) {
                    this.setBannerInsights(insightArray);
                }
            },
            addToInsight(array, metric, value) {
                if (Number(value) > 0) {
                    array.push(metric);
                }
            },
            checkInArray(value) {
                if (this.bannerInsights.includes(value)) {
                    return true;
                } else {
                    return false;
                }
            },
        },
        mounted() {
            if ((this.promotedArray.length + this.index) === BANNER_POSITION && this.currentPage === FIRST_PAGE) {
                this.calculateWhichBannerToShow();
            }
        },
        setup(props) {
            const getters = {
                ...useGetters(['language']),
                ...useGetters('globalSettings', ['contentOwners']),
                ...useGetters('search', ['entity', 'path', 'query', 'entityName', 'getIcon', 'getTitle', 'getContent', 'currentPage', 'getGroupType', 'currentPage', 'getTabGroup', 'bannerInsights', 'getOriginalMetric', 'promotedArray', 'applyFilterClicked', 'userPermissionToGCS', 'resetFilterClicked', 'loading']),
            };
            const actions = {
                ...useActions('search', [
                    'setBannerInsights',
                ]),
            };
            async function setBannerInsights(value) {
                await actions.setBannerInsights(value);
            }
            function contentOwner() {
                const owner = getters.contentOwners.value.find(owner => props.item.idowner === owner);

                return owner;
            }

            return {
                contentOwner,
                setBannerInsights,
                ...getters,
            };
        },
    };
</script>
